import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';

export default function TemplateSourceGuard({
  children,
}: {
  children: ReactNode;
}) {
  const location = useLocation();

  if (!location?.state) {
    return <Navigate to="/admin" />;
  }

  return <>{children}</>;
}
